module.exports = __webpack_public_path__ + "img/w4_feature_01.b9666d8e.jpg";